import { render, staticRenderFns } from "./PartnerManager.vue?vue&type=template&id=9c6215f8&"
import script from "./PartnerManager.vue?vue&type=script&lang=js&"
export * from "./PartnerManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports